import React from 'react';
import './Footer.css';
import './assets/daab.jpg';
import DAAB from './assets/daab.jpg';
import VFED from './assets/vfed.jpg';
import VÖD from './assets/vöd.png';



const Footer = () => (
  <div className="Footer">
    <div className="FooterWrapper">
      <div className='ContactData'>
        <div className='Contact'>Kontakt</div>
        <div>Katja Bär-Hanuja</div>
        <div>Derlerstraße 184</div>
        <div>66346 Püttlingen</div>
        <div>Tel: 06898/63374</div>
        <div>Email: <br></br>k.baer-hanuja@gmx.de</div>
      </div>
      
      <div className="DaabContainer"> <a href="https://www.daab.de/">
        <img  className="Daab" src={DAAB} alt="Test"></img>
      </a></div>
     
      
      <div className="VfedContainer"> <a href="https://www.vfed.de/de/">
        <img  className="Vfed" src={VFED} alt="Test"></img>
      </a></div>
     

      <div className="VodContainer"> <a  href="https://www.vdoe.de">
        <img  className="Vod"src={VÖD} alt="Test"></img>
      </a></div>
     

     

    </div>
  </div>

);

export default Footer;